var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{staticClass:"currency-icon",attrs:{"src":_vm.currency.wallet.currencyIcon,"alt":"currency-icon"}}),_c('span',[_vm._v(_vm._s(_vm.currency.wallet.currencyName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }